import { ContentHubLayout } from "@/components/content/ContentHubLayout";
import { INTERCITY_HUB } from "@/data/content/contentHubs";

/**
 * Menu “Popular Rides” opens the Intercity hub content fully expanded
 * (same sections as the Intercity hub page).
 */
export default function PopularRoutes() {
  return (
    <ContentHubLayout
      eyebrow="Popular Rides"
      title="Popular Rides on Duri"
      overview={INTERCITY_HUB.overview}
      sections={INTERCITY_HUB.sections}
      relatedHubs={INTERCITY_HUB.relatedHubs}
    />
  );
}
